<template>
  <div class="page">
    <Header title="用户手册" :show-back="true" />

    <van-cell-group v-if="marketName !== 'SAH'">
      <van-cell is-link to="/manual">
        <template #title>
          <a class="custom-title" :href="fileServer + '/static/pdf/易加网操作指南网页版.pdf'" target="_blank">易加网操作指南网页版.pdf</a>
        </template>
      </van-cell>
        <van-cell is-link to="/manual">
        <template #title>
          <a class="custom-title" :href="fileServer + '/static/pdf/易加网操作指南手机端.pdf'" target="_blank">易加网操作指南手机端.pdf</a>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import Header from '@/components/header'
import { mapState } from 'vuex'
export default {
  components: {
    Header
  },
  data () {
    return {
      fileServer: process.env.VUE_APP_FILE_SERVER,
      marketName: ''
    }
  },
  computed: {
    ...mapState({
      clientInfo: state => state.user.clientInfo
    })
  },
  created () {
    this.marketName = this.clientInfo.marketName
  },
  methods: {}
}
</script>

<style scoped lang="less">
  a {
    color: #333 !important;
    &:link {
      color: #333 !important;
    }
    &:visited {
      color: #333 !important;
    }
  }
</style>
